/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    AMENITIES_TYPE_TRIP_PREFERENCES,
    CAMPING_TYPES,
    ELECTRIC_TYPE,
    FLAT_CAMPING_FILTERS,
    KEY_CHARACTERISTICS_TYPE,
    OCCUPANTS_TYPE,
    SEARCH_FILTER_CAMPSITE_ELECTRICAL_REORDERED,
    VEHICLE_LENGTH_TYPE,
} from '../constants/filters/camping';

export const getPreferencesCategory = (key: string | undefined) => {
    const isCampingType = CAMPING_TYPES.find((v) => key?.includes(v.key));
    const isElectricType = ELECTRIC_TYPE.find((v) => key?.includes(v.key));
    const isAmenitiesType = AMENITIES_TYPE_TRIP_PREFERENCES.find((v) =>
        key?.includes(v.key)
    );
    const isElectricityHookup = SEARCH_FILTER_CAMPSITE_ELECTRICAL_REORDERED.find((v) =>
        key?.includes(v.key)
    );
    const isKeyCharacteristicType = KEY_CHARACTERISTICS_TYPE.find((v) =>
        key?.includes(v.key)
    );
    const isVehicleLength = key?.includes(VEHICLE_LENGTH_TYPE.key);
    const isOccupantLength = key?.includes(OCCUPANTS_TYPE.key);

    if (isCampingType || isVehicleLength) {
        return 'camping-type';
    }
    if (isElectricType) {
        return 'electricity';
    }
    if (isAmenitiesType) {
        return 'amenities';
    }
    if (isElectricityHookup) {
        return 'electricity-hookup';
    }
    if (isKeyCharacteristicType || isOccupantLength) {
        return 'key-characteristics';
    }
    return '';
};

export const getLegacyPreferenceKey = (
    value: string,
    legacyPreferences: { Value: string }[]
) => {
    const isLegacy = legacyPreferences.map((v) => v.Value)?.indexOf(value) !== -1;
    switch (true) {
        case value === 'campsite_accessible':
            return 'accessible';
        case value === 'campsite-equipment-tent':
            return 'tent';
        case value === 'campsite-equipment-rv' || value === 'campsite-equipment-trailer':
            return 'rmt';
        case value === 'campsite-amenities-water-hookup':
            return 'water-hookup';
        case value === 'campsite-amenities-sewer-hookup':
            return 'sewer-hookup';
        case value === 'campsite-amenities-shade':
            return 'shade';
        case value === 'campsite-amenities-pets-allowed':
            return 'pets';
        case value === 'campsite-amenities-electricity-hookup':
            return 'electricity-hookup';
        case isLegacy:
            return null;
        default:
            return value;
    }
};

export const getPreferencesPayload = (values: string[]) => {
    return values?.map((item) => {
        const current = FLAT_CAMPING_FILTERS?.find((v) => v.key === item);
        if (item.includes(OCCUPANTS_TYPE.key)) {
            return {
                Name: OCCUPANTS_TYPE?.key,
                Value: item,
                Category: getPreferencesCategory(OCCUPANTS_TYPE?.key),
            };
        }
        if (item.includes(VEHICLE_LENGTH_TYPE.key)) {
            return {
                Name: VEHICLE_LENGTH_TYPE?.key,
                Value: item,
                Category: getPreferencesCategory(VEHICLE_LENGTH_TYPE?.key),
            };
        }
        return {
            Name: current?.value,
            Value: current?.key,
            Category: getPreferencesCategory(current?.key),
        };
    });
};
